import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { base_url } from "../../base_urls";
import Breadcrumbs from "../../components/Breadcrumbs";
const MassSystems = () => {
  const [users, setUsers] = useState([]);
  console.log("users: ", users);
  useEffect(() => {
    axios
      .get(base_url + "api/massSystemsData/massSystems.json")
      .then((res) => setUsers(res.data))
      .catch((err) => console.log(err));
  }, []);

  const userElements = users.map((user, index) => ({
    key: index,
    id: user.id,
    title: user.title,
    department: user.department,
    description: user.description,
    url: user.url,
    type: user.type,
    location: user.location,
    salary: user.salary,
    posted: user.posted,
  }));
  return (
    <div>
      <div className="main-wrapper">
        {/* <Header /> */}
        <div className="page-wrapper ">
          {/* Page Content */}
          <div className="content container ">
            {/* Page Header */}
            <Breadcrumbs
              maintitle="Mass Systems "
              title="الرئيسية"
              subtitle="أنطمة Mass"
            />
            {/* /Page Header */}
            <div className="row">
              <div className="row">
                {Array.isArray(userElements) && userElements.length > 0
                  ? userElements.map((system, index) => (
                      <div className="col-md-6" key={index}>
                        <Link
                          className="job-list dark"
                          to={system.url}
                          target="_blank"
                        >
                          <div className="job-list-det">
                            <div className="job-list-desc">
                              <h3 className="job-list-title">{system.title}</h3>
                              <h4 className="job-department mb-2 mt-2 pt-2 color-cacaca ">
                                {system.department}
                              </h4>
                            </div>
                            <div className="job-type-info">
                              <span className="job-types">{system.type}</span>
                            </div>
                          </div>
                          <div className="job-list-footer">
                            <ul>
                              <li>
                                <i className="fa-solid fa-info text-primary fw-bold" />{" "}
                                <span className="font-14 color-cacaca">
                                  {" "}
                                  {system.description}
                                </span>
                              </li>
                              {/* <li>
                                <i className="fa-regular fa-money-bill-1" />{" "}
                                {job.salary}
                              </li>
                              <li>
                                <i className="fa-regular fa-clock" />{" "}
                                {job.posted}
                              </li> */}
                            </ul>
                          </div>
                        </Link>
                      </div>
                    ))
                  : " <p>No job listings available.</p>"}
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
      </div>
    </div>
  );
};

export default MassSystems;
